import axios from 'axios';
import { BASE_URL } from 'constants/env';

export const USER_STATUS = async (e) => {
  const res = await axios.post(BASE_URL + `/admin/userstatus`, {
    url_path: e.url_path,
  });
  return res.data;
};
